<template>
    <div class="clearfix">
        <Form ref="myForm" :model="formData" :labelWidth="80">
            <FormItem label="订单号" prop="orderId" :rules="required">
                <Input v-model="formData.orderId" readonly v-bind="inputProps">
                    <Icon
                        type="ios-search"
                        style="
                            font-size: 16px;
                            margin-right: 10px;
                            cursor: pointer;
                        "
                        slot="suffix"
                        @click="handleShowOrder"
                    />
                </Input>
            </FormItem>
            <FormItem
                :label="$t('global.common.notes', { defaultValue: '备注' })"
            >
                <Input v-model="formData.remark" type="textarea" :rows="3" />
                <div
                    class="color-error"
                    v-html="$t('erp.b2c.intercept_info')"
                ></div>
            </FormItem>
        </Form>
        <div class="pull-right padding-bottom-15">
            <Button class="margin-right-10" type="primary" @click="submit">{{
                $t("erp.distribution.confirm_submit", { defaultValue: "提交" })
            }}</Button>
            <Button @click="$emit('on-close')">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </div>
        <compModal v-model="modalProps.show" v-bind="modalProps">
            <compOrder
                @rows="handleOrderId"
                @on-cancel="modalProps.show = false"
            ></compOrder>
        </compModal>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import { HttpIntercept } from "@/service/boss/b2corder";
import compOrder from "./order.vue";
export default {
    components: {
        compOrder,
    },
    data() {
        return {
            loading: false,
            modalProps: {
                show: false,
            },
            formData: {
                remark: "",
            },
            required: [
                {
                    required: true,
                    message: this.$t("boss.purchase.item_cannot_empty", {
                        defaultValue: "此项不能为空",
                    }),
                },
            ],
        };
    },
    methods: {
        handleShowOrder() {
            this.modalProps = {
                show: true,
                width: 800,
                title: this.$t("boss.purchase.select_order", {
                    defaultValue: "选择订单",
                }),
                showFooter: false,
            };
        },
        handleOrderId(rows) {
            this.$set(this.formData, "orderId", rows.id);
            this.modalProps.show = false;
        },
        async submit() {
            let flag = true;
            await this.$refs.myForm.validate((valid) => {
                return (flag = valid);
            });
            if (!flag) return;
            this.loading = true;
            await HttpIntercept({
                orderId: this.formData.orderId,
                reason: this.formData.remark,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.$emit("on-update");
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
    },
};
</script>

<style></style>
